import { useNavigate, useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import {
    asyncGetParamWithNestedParent,
    asyncGetSubmotive3Historical,
} from '../../../../../services/param.service';
import { Param, ParamHistorical } from '../../../../../shared/types/param';
import { SUBMOTIVE3 } from '../../../../../routes/paths';

export const useSubmotive3Detail = () => {
    const [showHistorical, setShowHistorical] = useState(false);
    const navigate = useNavigate();
    const { idSubmotive3 } = useParams();
    const [loading, setLoading] = useState(false);
    const [submotive3, setSubmotive3] = useState<Param>();
    const [submotive3Historical, setSubmotive3Historical] =
        useState<ParamHistorical[]>();

    useEffect(() => {
        if (Boolean(idSubmotive3)) {
            setLoading(true);
            asyncGetParamWithNestedParent(idSubmotive3, 4)
                .then((submotive3: any) => {
                    if (!submotive3 || !submotive3.items) navigate(SUBMOTIVE3);
                    setSubmotive3(submotive3?.items);
                })
                .finally(() => setLoading(false));
        }
    }, [idSubmotive3]);

    useEffect(() => {
        if (showHistorical) {
            setLoading(true);
            asyncGetSubmotive3Historical(idSubmotive3)
                .then((resp) => {
                    if (resp) setSubmotive3Historical(resp);
                })
                .finally(() => setLoading(false));
        }
    }, [showHistorical]);

    return {
        loading,
        submotive3,
        submotive3Historical,
        showHistorical,
        setShowHistorical,
    };
};
